var _path, _path2, _g, _path3, _path4, _g2, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePictureDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7278_367725",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 100,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00195312H100V99.998H0V-0.00195312Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7278_367725)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7278_367725",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 100,
    height: 101
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 49.998C100 53.2767 99.6654 56.5387 99.0298 59.7505C98.3941 62.979 97.4406 66.1071 96.186 69.1349C94.9314 72.1627 93.3924 75.0399 91.5691 77.7833C89.7457 80.5099 87.6715 83.0359 85.3463 85.361C83.0211 87.6695 80.4951 89.7438 77.7685 91.5671C75.0418 93.3905 72.1646 94.9295 69.1201 96.1841C66.0923 97.4554 62.9642 98.3922 59.7524 99.0445C56.5239 99.6802 53.2787 99.998 50 99.998C46.7046 99.998 43.4594 99.6802 40.2309 99.0445C37.0191 98.3922 33.8909 97.4554 30.8632 96.1841C27.8187 94.9295 24.9415 93.3905 22.2148 91.5671C19.4881 89.7438 16.9622 87.6695 14.637 85.361C12.3118 83.0359 10.2375 80.5099 8.41419 77.7833C6.59084 75.0399 5.05186 72.1627 3.79726 69.1349C2.54266 66.1071 1.58916 62.979 0.953496 59.7505C0.317834 56.5387 0 53.2767 0 49.998C0 46.7194 0.317834 43.4574 0.953496 40.2456C1.58916 37.0171 2.54266 33.889 3.79726 30.8612C5.05186 27.8334 6.59084 24.9562 8.41419 22.2128C10.2375 19.4862 12.3118 16.9602 14.637 14.635C16.9622 12.3266 19.4881 10.2523 22.2148 8.42896C24.9415 6.60561 27.8187 5.06663 30.8632 3.81203C33.8909 2.5407 37.0191 1.60393 40.2309 0.951541C43.4594 0.315879 46.7046 -0.00195312 50 -0.00195312C53.2787 -0.00195312 56.5239 0.315879 59.7524 0.951541C62.9642 1.60393 66.0923 2.5407 69.1201 3.81203C72.1646 5.06663 75.0418 6.60561 77.7685 8.42896C80.4951 10.2523 83.0211 12.3266 85.3463 14.635C87.6715 16.9602 89.7457 19.4862 91.5691 22.2128C93.3924 24.9562 94.9314 27.8334 96.186 30.8612C97.4406 33.889 98.3941 37.0171 99.0298 40.2456C99.6654 43.4574 100 46.7194 100 49.998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7278_367725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00195312V99.998H100V-0.00195312H0Z",
    fill: "#F2F0FF"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7278_367725",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 17,
    width: 69,
    height: 65
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.373 17.4619H83.8909V81.6974H15.373V17.4619Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7278_367725)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7278_367725",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 19,
    width: 64,
    height: 62
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.724 61.9369L72.8839 70.2675C72.8504 71.5723 72.5828 72.8269 72.081 74.0145C71.5791 75.219 70.8598 76.2896 69.9398 77.2096C69.0365 78.1296 67.9659 78.8657 66.7782 79.3842C65.5905 79.9028 64.3359 80.1704 63.0311 80.2206C61.7263 80.2541 60.4717 80.0534 59.2506 79.6017C58.0127 79.15 56.9254 78.4977 55.9552 77.6278C54.9849 76.7412 54.2154 75.7208 53.63 74.5666C53.0612 73.3956 52.7267 72.1577 52.6263 70.853C51.8401 70.2842 50.9535 70.0166 49.9833 70.0166C49.013 70.0166 48.1432 70.2842 47.357 70.853C45.9685 83.6164 27.7517 83.0979 27.0826 70.2675L25.2593 62.0206C25.1589 61.5856 25.2425 61.1674 25.4767 60.7994C25.7277 60.4147 26.0622 60.1805 26.5139 60.0801C26.9488 59.9798 27.3503 60.0467 27.735 60.2809C28.1198 60.5318 28.354 60.8663 28.4711 61.3013L29.09 64.0447C30.2442 62.5057 31.7163 61.3849 33.5062 60.6823C35.2961 59.9798 37.1362 59.7957 39.0264 60.147C40.9334 60.4816 42.5895 61.3013 44.0281 62.5893C45.45 63.8774 46.4369 65.4331 46.989 67.2899C48.9796 66.4368 50.9869 66.4368 52.9776 67.2899C53.5129 65.4331 54.4998 63.8439 55.9384 62.5559C57.3603 61.2511 59.0331 60.4314 60.9401 60.0968C62.8304 59.7623 64.6872 59.9463 66.4771 60.6489C68.267 61.3682 69.739 62.5057 70.8933 64.0614L71.5122 61.2176C71.6126 60.766 71.8635 60.4314 72.2482 60.1805C72.633 59.9463 73.0345 59.8627 73.4861 59.963C73.9378 60.0634 74.2723 60.3143 74.5232 60.6991C74.7574 61.0838 74.8243 61.502 74.724 61.9369ZM73.553 39.856C74.0716 40.96 74.8076 42.4823 73.3356 43.2518C72.9174 43.4692 72.4824 43.5027 72.0475 43.3354C71.5958 43.1848 71.278 42.8837 71.094 42.4655C68.5179 36.4602 66.8953 31.9604 63.5329 23.312C63.1315 22.2748 62.4791 21.4384 61.559 20.786C60.6557 20.1504 59.6353 19.8158 58.5145 19.7991C56.2395 19.5816 53.0947 22.2748 51.2211 23.2952C50.4349 23.7804 49.6487 23.7804 48.8792 23.2952L44.5467 20.602C43.8441 20.1671 43.1081 19.9162 42.2884 19.8158C41.4854 19.7155 40.6992 19.7991 39.9297 20.05C39.1602 20.3009 38.4744 20.7024 37.8889 21.2544C37.2867 21.8064 36.8351 22.4588 36.5339 23.2116C35.4132 25.9717 29.7926 40.0902 28.8056 42.5157C28.6718 42.9674 28.3874 43.2852 27.9692 43.5027C27.551 43.7034 27.1161 43.7201 26.6812 43.5696C26.2462 43.4023 25.9284 43.1179 25.7444 42.683C25.5436 42.2648 25.5436 41.8299 25.7109 41.4117L25.7611 41.2946L26.3131 39.8894C22.2482 41.3782 18.7354 43.603 18.7354 46.8817C18.8692 60.6656 81.1308 60.6656 81.2479 46.8817C81.2479 43.5863 77.6848 41.3448 73.553 39.856Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7278_367725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7354 19.5811V83.6158H81.2479V19.5811H18.7354Z",
    fill: "url(#paint0_linear_7278_367725)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49.998,
    r: 50,
    fill: "#7043FF",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7278_367725",
    x1: 18.7427,
    y1: 49.9927,
    x2: 81.2422,
    y2: 49.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#01BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#02BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#02BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#03BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#04BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#04BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#05BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#06B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#06B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#07B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#08B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#08B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#09B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#0AB4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0AB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#0BB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#0CB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#0CB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#0DB0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#0EAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#0EAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#0FAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#10ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#10ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#11ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#12AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#12AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#13A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#14A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#14A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#15A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#16A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#16A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#17A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#18A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#18A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#19A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#1AA1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#1B9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#1C9EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#1C9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#1D9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#1E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#1E9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#1F9AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#2099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#2198FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#2197FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2296FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#2395FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#2395FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#2494FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#2593FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#2592FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#2691FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#2790FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#2790FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#288FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#298EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#298DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#2B8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#2B8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#2C8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#2D89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#2D88FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2E88FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#2F87FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#2F86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3184FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#3183FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3283FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#3382FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3381FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3480FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#357FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#357FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#367EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#377DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#377CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#387BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#397BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#397AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#3A79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#3B78FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#3B77FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#3C76FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#3D76FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#3D75FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#3E74FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#3F73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3F72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4072FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4171FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#4170FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#426FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#436EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#436EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#446DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#456CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#456BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#4769FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#4769FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#4868FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#4967FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#4966FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4A65FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#4B65FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#4B64FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#4C63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#4D62FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#4D61FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#4E61FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#4F60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#4F5FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#505EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#515DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#515CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#525CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#535BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#535AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#5459FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5558FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePictureDefault);
export default __webpack_public_path__ + "static/media/profilePictureDefault.027ddd415331ec7150fa2a455e7ab4f2.svg";
export { ForwardRef as ReactComponent };